'use strict';

var isClient = typeof window !== 'undefined';

var isIOS = isClient ? require('../util/is_ios')() : {};

module.exports = {
  UNIVERSAL_LINK: {
    // IOS9.0之后支持的Universal Link，能绕过IOS的打开弹窗询问
    // 暂时弃用
    UC_BROWSER: 'http://iflow.uczzd.cn/ucbrowser/openapp.html?encodeURIComponent({goToURL})'
  },

  INTENTS_LINK: {
    // Android的Intents协议调用，具体请见 https://developer.chrome.com/multidevice/android/intents
    // 国际版在10.6.2添加，个人，国际版通用，但是没有同步到个人版
    // 大概只能在 Android Chrome 中使用
    UC_BROWSER: 'intent://{goToURL}#Intent;scheme=ucbrowser;package=com.UCMobile;end',
    UC_NEWS: 'intent://{goToURL}#Intent;scheme=ucnews;package=com.uc.infoflow;end',
    UC_BROWSER_INTL: 'intent://{goToURL}#Intent;scheme=ucweb;package=com.UCMobile.intl;end',
    UC_NEWS_INTL: 'intent://{goToURL}&_no_app_launch=1&download_url={downloadUrl}&download_switch=1&uc_biz_str=action:base.openwindow|param:S.object=infoflow;S.scene=1003;end#Intent;scheme=ucnewsintl;package=com.uc.iflow;end',
    UC_LITE: 'intent://data?ref={goToURL}#Intent;scheme=ucdownload;package=com.uc.browser.en;end'
  },

  // 卑鄙地发现国内UC Browser跟国际UC Browser使用的scheme前缀居然是一样的
  SCHEME_LINK: {
    UC_BROWSER: isIOS ? 'ucbrowser://{goToURL}' : 'ucweb://{goToURL}',
    UC_NEWS: 'ucnews://{goToURL}',
    UC_BROWSER_INTL: isIOS ? 'ucbrowser://{goToURL}' : 'ucweb://{goToURL}',
    UC_NEWS_INTL: 'ucnewsintl://{goToURL}&_no_app_launch=1&download_url={downloadUrl}&download_switch=1&uc_biz_str=action:base.openwindow|param:S.object=infoflow;S.scene=1003;end',
    UC_LITE: 'ucdownload://data?ref={goToURL}',
    COMMON: '{goToURL}'
  }
};